import banyantree from '../../shared/lib/banyantree';

// Customer Type has to be either Deposit or Loan
const getProducts = () => banyantree();

const ProductService = {
    getProducts
};

export default ProductService;